import { AutoFixHighFilled, EmergencyHomeFilled } from "@clockwise/icons";
import React from "react";
import { SecondaryCard } from ".";
import { Item } from "./Item";

export const Break: React.FC<{ type: SecondaryCard }> = ({ children, type }) => {
  if (!children) {
    return null;
  }

  let Icon = null;
  switch (type) {
    case "sbm":
      Icon = <AutoFixHighFilled className="cw-h-4 cw-w-4 cw-text-busy" />;
      break;
    case "unavailable":
      Icon = <EmergencyHomeFilled className="cw-text-warning-muted cw-h-4 cw-w-4" />;
      break;
  }

  return (
    <>
      <Item
        alignTop
        left={
          <div className="cw-w-8 cw-h-6 cw-bg-neutral cw-rounded-full cw-flex cw-items-center cw-justify-center">
            {Icon}
          </div>
        }
        right={
          <div className="cw-body-sm cw-font-medium cw-flex cw-flex-col cw-gap-0.5">{children}</div>
        }
      />
    </>
  );
};
